import Alpine from "alpinejs";
import { $http } from "../../utils";

Alpine.store('products', {
    products: [],
    loading: true,

    init() {
        this.fetchProducts();
    },

    fetchProducts() {
        this.loading = true;
        let basketProducts = Alpine.store('basket').basketProducts.map(item => item.id);
        let favouriteProducts = Alpine.store('favourite').products.map(item => item.id);
        let mergedArray = Array.from(new Set([...basketProducts, ...favouriteProducts]));
        $http.get(`/api/v1/product-variants?ids=${mergedArray}`)
            .then((response) => {
                this.products = response.data.data;
            })
            .finally(() => {
                this.loading = false;
            })
    },

    getProductById(id) {
        return this.products.find(item => item.id === id);
    }
})